export enum Role {
  Resident = 'resident',
  Admin = 'admin',
  Technician = 'technician',
}
